import PropTypes from 'prop-types';
import classNames from 'classnames';
import StatisticsCount from '../../common/StatisticsCount';

const OverdueChartSummaryStats = ({ salesTotal = 0, overdueTotal = 0, orderCount = 0, loading = false, isFiltered = false, className }) => (
	<div
		className={classNames('statistics-overdue-chart-summary-stats', isFiltered ? 'statistics-overdue-chart-summary-stats--filtered' : null, className)}
		role='group'
		aria-label='超期图表汇总'
	>
		<div className='statistics-overdue-chart-summary-stats__item'>
			<div className='statistics-overdue-chart-summary-stats__value'>
				<StatisticsCount value={salesTotal} loading={loading} mode='currency' duration={0.45} />
			</div>
			<div className='statistics-overdue-chart-summary-stats__label'>销售总额</div>
		</div>
		<div className='statistics-overdue-chart-summary-stats__divider' aria-hidden />
		<div className='statistics-overdue-chart-summary-stats__item'>
			<div className='statistics-overdue-chart-summary-stats__value statistics-overdue-chart-summary-stats__value--overdue'>
				<StatisticsCount value={overdueTotal} loading={loading} mode='currency' duration={0.45} />
			</div>
			<div className='statistics-overdue-chart-summary-stats__label'>超期总额</div>
		</div>
		<div className='statistics-overdue-chart-summary-stats__divider' aria-hidden />
		<div className='statistics-overdue-chart-summary-stats__item'>
			<div className='statistics-overdue-chart-summary-stats__value'>
				<StatisticsCount value={orderCount} loading={loading} duration={0.45} />
				<span className='statistics-overdue-chart-summary-stats__suffix'>单</span>
			</div>
			<div className='statistics-overdue-chart-summary-stats__label'>订单总数</div>
		</div>
	</div>
);

OverdueChartSummaryStats.propTypes = {
	salesTotal: PropTypes.number,
	overdueTotal: PropTypes.number,
	orderCount: PropTypes.number,
	loading: PropTypes.bool,
	isFiltered: PropTypes.bool,
	className: PropTypes.string,
};

export default OverdueChartSummaryStats;
